// app/javascript/modules/admissoes/adiantamento.js
//
// Checkbox:  #params_tem_adiantamento
// Input:     #params_percentual_adiantamento
//
// Regra:
// - desmarcado: disabled (não enviado), visual "cinza", valor preservado
// - marcado: readonly (enviado, não editável), preenche % do condomínio

export function initAdiantamento($j, $form, h) {
  if (!$form || !$form.length) return { destroy() { } }

  const $chk = $form.find("#admissao_tem_adiantamento").first()
  const $pct = $form.find("#params_percentual_adiantamento").first()

  if (!$chk.length || !$pct.length) return { destroy() { } }

  let $alerta = $form.find("#adiantamento-alerta")
  if (!$alerta.length) {
    $alerta = $j('<div id="adiantamento-alerta" class="hidden mt-1 rounded-md border border-red-300 bg-red-50 px-3 py-2 text-sm text-red-700"></div>')
    $pct.closest("div").after($alerta)
  }

  function parsePct(val) {
    if (!val) return NaN
    return parseFloat(String(val).replace(",", "."))
  }

  function validaLimite() {
    if (!$chk.is(":checked")) { $alerta.addClass("hidden").empty(); return }
    const v = parsePct($pct.val())
    if (!isNaN(v) && v > 40) {
      $alerta.removeClass("hidden").html('<i class="fas fa-exclamation-circle mr-1"></i>O percentual máximo permitido é de <strong>40%</strong>, conforme a Convenção Coletiva de Trabalho (CCT).')
      $form.data("adiantamento-bloqueado", true)
    } else {
      $alerta.addClass("hidden").empty()
      $form.data("adiantamento-bloqueado", false)
    }
  }

  function apply() {
    const checked = $chk.is(":checked")

    if (!checked) {
      // disabled = não enviado no submit; sem clearValue pois basta não enviar
      $pct.prop("disabled", true).prop("readonly", false)
      $pct.addClass("bg-gray-100 text-gray-500")
      $alerta.addClass("hidden").empty()
      $form.data("adiantamento-bloqueado", false)
    } else {
      // readonly = enviado no submit, mas não editável pelo usuário
      $pct.prop("disabled", false).prop("readonly", true)
      $pct.removeClass("bg-gray-100 text-gray-500")
      const pctCondominio = $pct.data("percentual-condominio")
      if (pctCondominio != null && pctCondominio !== "") {
        $pct.val(pctCondominio)
        // Formata via máscara (ex: "40" → "40%") sem disparar eventos que causam cascata
        try { $pct[0].dispatchEvent(new Event("blur")) } catch (_) {}
      } else {
        // pctCondominio ainda não disponível: remove required para evitar falso positivo
        $pct[0]?.removeAttribute("required")
        $pct[0]?.removeAttribute("aria-required")
      }
      validaLimite()
    }
  }

  $chk.off("change.admAdianta").on("change.admAdianta", apply)

  // bloqueia submissão se percentual inválido
  $form.off("submit.admAdianta").on("submit.admAdianta", function (e) {
    if ($form.data("adiantamento-bloqueado")) {
      e.preventDefault()
      e.stopImmediatePropagation()
      $alerta.removeClass("hidden")
      $pct[0]?.scrollIntoView({ behavior: "smooth", block: "center" })
    }
  })

  apply()

  return {
    destroy() {
      $chk.off(".admAdianta")
      $pct.off(".admAdianta")
      $form.off("submit.admAdianta")
    },
  }
}
